module.exports = __webpack_public_path__ + "static/media/Landing Page_Beneficios CELULAR.67895eb2.jpg";